import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n/config";
import heroBg from "@/assets/hero-bg.webp";

// Preload LCP image as early as possible so the browser can discover it
// from the initial document parse (improves LCP discovery).
const preloadLink = document.createElement("link");
preloadLink.rel = "preload";
preloadLink.as = "image";
preloadLink.href = heroBg;
preloadLink.fetchPriority = "high";
document.head.appendChild(preloadLink);

createRoot(document.getElementById("root")!).render(<App />);
